import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDishwasher = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	fill: "#000000",
	height: "800px",
	width: "800px",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 315 315",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	enableBackground: "new 0 0 315 315",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", { d: "M285.333,0H29.667c-3.866,0-7,3.134-7,7v301c0,3.866,3.134,7,7,7h255.666c3.866,0,7-3.134,7-7V7   C292.333,3.134,289.199,0,285.333,0z M278.333,14v52.127H36.667V14H278.333z M36.667,301V80.127h241.666V301H36.667z" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 77.268,
			cy: 40.063,
			r: 8.29
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 109.094,
			cy: 40.063,
			r: 8.29
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 140.919,
			cy: 40.063,
			r: 8.29
		}),
		/* @__PURE__ */ _jsx("path", { d: "m190.665,173.741c1.683-1.055 3.261-2.301 4.699-3.739 5.003-5.004 7.759-11.657 7.759-18.735 0-3.598-1.219-7.838-3.726-12.961-1.715-3.507-4.075-7.51-7.017-11.898-4.89-7.294-9.885-13.377-9.902-13.397l-.442-.538c-1.33-1.617-3.313-2.555-5.407-2.555-2.094,0-4.077,0.938-5.407,2.555l-.476,.578c-0.856,1.051-5.359,6.631-9.869,13.358-2.939,4.388-5.3,8.39-7.016,11.897-1.571,3.212-2.636,6.073-3.212,8.647h-41.089c-3.866,0-7,3.134-7,7 0,19.595 2.861,34.463 8.747,45.453 6.296,11.754 16.211,18.782 28.902,20.639v37.165h-14.399c-3.866,0-7,3.134-7,7 0,3.866 3.134,7 7,7h42.798c3.866,0 7-3.134 7-7 0-3.866-3.134-7-7-7h-14.398v-37.143c24.927-3.518 33.721-25.934 36.455-46.326zm-24.227-29.284c1.439-2.94 3.481-6.392 6.069-10.255 1.411-2.104 2.834-4.104 4.123-5.855 1.284,1.746 2.705,3.743 4.122,5.855 2.589,3.863 4.631,7.313 6.069,10.255 2.136,4.365 2.302,6.316 2.302,6.81 0,3.338-1.3,6.476-3.659,8.836-2.359,2.359-5.497,3.659-8.835,3.659-3.337,0-6.475-1.3-8.834-3.66-2.361-2.36-3.661-5.498-3.661-8.835 5.68434e-14-0.493 0.166-2.439 2.304-6.81zm-49.732,16.496h35.255c1.314,3.35 3.313,6.427 5.934,9.049 4.829,4.828 11.193,7.555 17.99,7.742-2.716,14.24-9.465,28.816-28.675,28.816-7.229,0.001-28.537-0.003-30.504-45.607z" }),
		/* @__PURE__ */ _jsx("path", { d: "m222.314,189.059c-4.51-6.727-9.011-12.308-9.904-13.403l-.442-.537c-1.329-1.613-3.31-2.549-5.399-2.55-0.001,0-0.003,0-0.003,0-2.09,0-4.069,0.933-5.399,2.544l-.464,.563c-0.518,0.633-5.198,6.384-9.891,13.383-2.936,4.38-5.297,8.383-7.016,11.896-2.508,5.127-3.727,9.367-3.727,12.963 0,7.077 2.756,13.73 7.759,18.734 5.005,5.005 11.659,7.761 18.736,7.761 7.076,0 13.729-2.756 18.734-7.761 5.004-5.005 7.76-11.658 7.76-18.734 0-3.6-1.22-7.84-3.727-12.962-1.726-3.529-4.087-7.532-7.017-11.897zm-6.916,33.692c-2.36,2.361-5.498,3.661-8.834,3.661-3.338,0-6.476-1.3-8.836-3.661-2.359-2.359-3.659-5.496-3.659-8.834 0-0.493 0.166-2.442 2.303-6.812 1.441-2.946 3.483-6.395 6.068-10.251 1.413-2.108 2.836-4.107 4.123-5.857 1.289,1.753 2.712,3.752 4.124,5.859 2.579,3.842 4.62,7.29 6.068,10.251 2.137,4.363 2.303,6.314 2.303,6.809 0.001,3.338-1.299,6.476-3.66,8.835z" })
	] })]
});
const ForwardRef = forwardRef(SvgDishwasher);
export { ForwardRef as ReactComponent };
